import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Table} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {hasAnyPermission} from 'app/shared/auth/permissions';
import {IRootState} from 'app/shared/reducers';
import {getEntities} from './rejection-reason.reducer';
import {IRegion} from "app/shared/model/region.model";
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {getAllByType as getCountries} from "app/entities/region/region.reducer";

export interface IRejectionReasonAmbulanceProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const RejectionReasonAmbulance = (props: IRejectionReasonAmbulanceProps) => {
  const {countries, rejectionReasonAmbulanceList, match, loading, userCountryId} = props;
  const [activeCountry, setActiveCountry] = useState<IRegion>({});

  useEffect(() => {
    props.getEntities();
    if (!countries || countries.length === 0) {
      props.getCountries();
    }
  }, []);

  useEffect(() => {
    if (countries && countries.length > 0) {
      const ac = countries.find(country => country.id === userCountryId);
      setActiveCountry(ac);
    }
  }, [countries, userCountryId]);

  const onCountryChange = (event) => {
    const countryId = event.target.value;
    const newActiveCountry = props.countries.find(country => country.id === countryId);
    setActiveCountry(newActiveCountry);
  };

  const regCountriesList = props.countries.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === activeCountry?.id;
  });

  return (
    <div>
      <h2 id="rejection-reason-ambulance-heading">
        Rejection Reason (Ambulance)
        {activeCountry && (
          <AvForm>
            <AvGroup>
              <AvInput id="ambulance-countries" type="select" className="form-control" name="ambulance-country"
                       value={activeCountry.id} onChange={onCountryChange}>
                {regCountriesList
                  ? regCountriesList.map(country => (
                    <option value={country.id} key={country.id}>
                      {country.name}
                    </option>
                  ))
                  : null}
              </AvInput>
            </AvGroup>
          </AvForm>
        )}
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus"/>
          &nbsp; Create new Rejection Reason
        </Link>
      </h2>
      <div className="table-responsive">
        {rejectionReasonAmbulanceList && rejectionReasonAmbulanceList.length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th>ID</th>
              <th>Rejection Reason (English)</th>
              <th>Rejection Reason (Local Language)</th>
              <th>Country</th>
              <th>Active</th>
              <th/>
            </tr>
            </thead>
            <tbody>
            {rejectionReasonAmbulanceList.filter((v) => activeCountry?.id === v?.countryId).map((rejectionReasonAmbulance, i) => (
              <tr key={`entity-${i}`}>
                <td>
                  <Button tag={Link} to={`${match.url}/${rejectionReasonAmbulance.id}`} color="link" size="sm">
                    {rejectionReasonAmbulance.id}
                  </Button>
                </td>
                <td>{rejectionReasonAmbulance.enRejectionReason}</td>
                <td>{rejectionReasonAmbulance.stRejectionReason}</td>
                <td>{props.countries.find(country => country.id === rejectionReasonAmbulance.countryId)?.name}</td>
                <td>{rejectionReasonAmbulance.isActive ? 'Yes' : 'No'}</td>

                <td className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button tag={Link} to={`${match.url}/${rejectionReasonAmbulance.id}`} color="info" size="sm">
                      <FontAwesomeIcon icon="eye"/> <span className="d-none d-md-inline">View</span>
                    </Button>
                    <Button tag={Link} to={`${match.url}/${rejectionReasonAmbulance.id}/edit`} color="primary" size="sm">
                      <FontAwesomeIcon icon="pencil-alt"/> <span className="d-none d-md-inline">Edit</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Rejection Reasons found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({rejectionReasonAmbulance, authentication, region}: IRootState) => ({
  rejectionReasonAmbulanceList: rejectionReasonAmbulance.entities,
  loading: rejectionReasonAmbulance.loading,
  countries: region.countries,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntities,
  getCountries,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RejectionReasonAmbulance);
